export default "__VITE_ASSET__DuaIr5HX__"